import React, { Component } from 'react';

export class CheckBoxRenderer extends Component {
    render() {
        return (
            <input
                type="checkbox"
                checked={this.props.value}
            />
        )
    }
}
